import {AppPage} from "common/Layout";
import {AppText} from "shared/UI/UIKit/Text";
import type {TargetPage as TargetPageType} from "../../config/types";
import {GLOBAL_CONFIG} from "../../config/config";
import {PageType} from "../../config/types";
import styles from "./styles.module.scss";

export const TargetPage = () => {
  const targetPage = GLOBAL_CONFIG.pages.find(page => page.type === PageType.TARGET) as TargetPageType;

  if (!targetPage) {
    return null;
  }

  return (
    <AppPage contentClassName={styles.content} pageTitle="Цели" documentTitle="Цели">
      <AppText className={styles.title} size={24}>Цели</AppText>
      <div className={styles.target}>
        <div className={styles.cornerBottom}/>
        <div className={styles.cornerTop}/>
        <div className={styles.cornerRight}/>
        <div className={styles.cornerLeft}/>
        <AppText size={32}>
          {targetPage.text}
        </AppText>
      </div>
    </AppPage>
  );
};

